import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export const schema = {
  type: 'object',
  properties: {
    name: {
      title: 'name',
      type: 'string',
      placeholder: 'namePlaceholder'
    },
    id: {
      type: 'string'
    },
    permissions: {
      type: 'object',
      title: 'permissions',
      properties: {
        create: {
          type: 'boolean',
          title: 'create',
          default: false
        },
        read: {
          type: 'boolean',
          title: 'read',
          default: false
        },
        update: {
          type: 'boolean',
          title: 'write',
          default: false
        }
      }
    }
  }
};

export const uiSchema = {
  'ui:rootFieldId': 'form-roles',
  name: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  id: {
    'ui:field': 'HiddenId'
  },
  permissions: {
    create: {
      'ui:field': 'Checkbox',
      noLegend: true
    },
    read: {
      'ui:field': 'Checkbox',
      noLegend: true
    },
    update: {
      'ui:field': 'Checkbox',
      noLegend: true
    }
  }
};

export const translateSchema = (inputSchema) => {
  function translateProperties (inputProperties) {
    const outputProperties = inputProperties;
    const keys = Object.keys(inputProperties);
    for (let i = 0; i < keys.length; i++) {
      if (inputProperties[keys[i]].title) outputProperties[keys[i]].title = funcTranslateHelper(`Builder:Roles:form:${inputProperties[keys[i]].title}`);
      if (inputProperties[keys[i]].placeholder) outputProperties[keys[i]].placeholder = funcTranslateHelper(`Builder:Roles:form:${inputProperties[keys[i]].placeholder}`);
      if (inputProperties[keys[i]].properties) outputProperties[keys[i]].properties = translateProperties(inputProperties[keys[i]].properties);
    }

    return outputProperties;
  }

  inputSchema.properties = translateProperties(inputSchema.properties);
}
;
